











































































































































































































































































































































































































































































































































































































































































































































































































import { Vue, Component } from "vue-property-decorator";
import { namespace } from "vuex-class";
import { Gradient, FontFamily } from "../../types";

const Customization = namespace("customization");

@Component({})
export default class Welcome extends Vue {
  @Customization.Getter("getAccentColor") accentColor: string;
  @Customization.Getter("getSecondaryColor") secondaryColor: string;
  @Customization.Getter("getGradient") gradient: Gradient;
  @Customization.Getter("getFontFamily") fontFamily: FontFamily;
}
